// Simple content for demo
module.exports = {
  textInputId: 'search-input',
  inputLabel: 'Search',
  buttonLabel: 'Search',
};
